module.exports = __webpack_public_path__ + "assets/img/biz-img-shop-module-default.5322c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/biz-img-shop-module-default.png
// module id = 421
// module chunks = 1